import { styled } from '../../hooks/theme';

interface ProgressBarProps {
  progress: number;
}

export const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
`;

export const FileControlContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const FileInfoContainer = styled.div`
  gap: 8px;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  p {
    margin: 0;
    font-size: 16px;
    line-height: 150%;
    color: ${props => props.theme.colors.neutral.grey[70]};
  }
`;

export const ProgressBarContainer = styled.div`
  margin: 0;
  position: relative;

  width: 200px;
  height: 6px;

  background: ${props => props.theme.colors.neutral.grey[5]};
  border-radius: 10px;
`;

export const ProgressBar = styled.div<ProgressBarProps>`
  margin: 0;
  position: absolute;

  width: ${props => (props.progress < 1 ? props.progress * 100 : 100)}%;
  height: 6px;

  background: ${props => props.theme.colors.brand.primary[100]};
  border-radius: 10px;
`;
